<template>
  <div>
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
@import '~project-common-mobile/src/style/index.css';
</style>
